import Modal from '../../organisms/Modal';
import styles from './PrivacyPolicy.module.scss';
import FormHeader from '../../atoms/FormHeader';
import { useEffect, useRef, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import Button from '../../atoms/Button';
import { trpc } from '../../../utils/trpc';
import Emitter from '../../../utils/eventemitter';
import { debounce } from 'lodash';

export const PrivacyPolicy = ({setClose}: any) => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const isMobile = window.matchMedia('(max-width: 64rem)').matches;

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const privacyPolicy = trpc.mainService.patient.submitPrivacyPolicy.useMutation();

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch('https://mymentis.it/wp-json/wp/v2/pages/2630');
        if (!response.ok) {
          throw new Error('Error loading content');
        }
        const data = await response.json();
        const cleanContent = data.content.rendered
          .replace(/&nbsp;/g, ' ')
          .replace(/&amp;/g, '&')
          .replace(/ /g, ' ')
          .replace(/\s+/g, ' ');
        setContent(cleanContent);
      } catch (err: any) {
        console.error(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContent();
  }, []);

  useEffect(() => {
    const handleScroll = debounce(() => {
      if (!scrollContainerRef.current) return;
      const element = scrollContainerRef.current;
      const isAtBottom =
        element.scrollHeight - element.scrollTop <=
        element.clientHeight + 30;
      setIsButtonEnabled(isAtBottom);
    }, 100);

    const containerElem = scrollContainerRef.current;
    if (containerElem) {
      containerElem.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (containerElem) {
        containerElem.removeEventListener('scroll', handleScroll);
      }
      handleScroll.cancel();
    };
  }, [isLoading, isMobile]);

  const handlePrivacyPolicy = async () => {
    try {
      const response = await privacyPolicy.mutateAsync();
      if (response.message === 'Privacy policy submitted successfully') {
        setClose(false);
        Emitter.emit('updateInfo');
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal modal subClassName={!isLoading && 'fixedHeader'}>
      {isLoading ? (
          <Spin indicator={<LoadingOutlined style={{fontSize: 32}} spin/>}/>
        ) :
        <>
          <FormHeader
            title={`Ciao, abbiamo aggiornato i termini e le condizioni del nostro servizio. Per poter continuare il tuo percorso di benessere, scorri fino in fondo e clicca "Conferma"`}
            closeModal={setClose}
            className={styles.header}
          ></FormHeader>
          <div className={styles.privacyPolicyContent} ref={scrollContainerRef}>
            <div className={styles.content} dangerouslySetInnerHTML={{__html: content}}/>
          </div>
          <div className={styles.buttonWrapper}>
            <Button onClick={handlePrivacyPolicy} className={styles.button} disabled={!isButtonEnabled}
                    variant="primary">
              Conferma
            </Button>
          </div>
        </>
      }
    </Modal>
  );
};
